import cs from 'classnames';
import type { ReactNode } from 'react';

import styles from './round-element.module.css';

type P = {
  children: ReactNode;
  className?: string;
  color?: 'default' | 'success';
  size?: 'extra-extra-small' | 'extra-small' | 'large' | 'medium' | 'small';
};

const RoundElement = ({ children, className, color, size }: P) => (
  <div
    className={cs(styles['round-element'], className, {
      [styles.default ?? '']: color === 'default',
      [styles.large ?? '']: size === 'large',
      [styles.medium ?? '']: size === 'medium',
      [styles.small ?? '']: size === 'small',
      [styles.success ?? '']: color === 'success',
      [styles['extra-extra-small'] ?? '']: size === 'extra-extra-small',
      [styles['extra-small'] ?? '']: size === 'extra-small',
    })}
  >
    {children}
  </div>
);

export default RoundElement;
